import {
  Component, OnInit,
} from '@angular/core';
import {Router} from '@angular/router';
import {TreeNode} from 'primeng/api';
import _ from 'lodash';
import {InsparkMessageService} from '@inspark/inspark-components/full';
import {ObjrubricApiService} from '../../../../projects/api/src/objrubric/objrubric-api.service';
import {
  createObjectExpandedTreeByKey,
  searchItem,
  searchItemExpanded
} from '../../../../projects/common/modules/inspark-page-standard-forms/standard-form-builder/standard-form.helpers';
import {gettext} from '../../shared/gettextMarker.function';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    selector: 'app-select-object-tree',
    templateUrl: './select-object-tree.component.html',
    styleUrls: ['./select-object-tree.component.scss'],
    standalone: false
})
export class SelectObjectTreeComponent implements OnInit {

  objects: any[];
  selected: any;
  objfilter = '';
  title: string =  null;
  allObjects = false;
  objs;
  objactions: string[] = null;
  objaction: string;
  searchByObjects = false;
  isAppend = true;
  isShowSpinner = true;

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private messageService: InsparkMessageService,
              public rubricService: ObjrubricApiService,
              public router: Router,
              ) {

  }

  ngOnInit() {
    this.selected = [];
    this.title = this.config.data.title;
    const selected = this.config.data.objects;
    this.objactions = this.config.data.objactions;
    this.objaction = this.config.data.objaction;
    this.isAppend = !this.objactions;
    // shortest=true: дерево строится только по id/shortname/objrubric — теги/статусы/контроллеры не читаются
    // (см. includeStatuses в ObjrubricApiService.createObjectTree).
    this.rubricService.getTreeObjects(null, true).subscribe(items => {
      this.objs = [];
      items.forEach(node => {
        if (this.hasObjects(node)) {
          this.objs.push(node);
        }
      });
      this.sortNodes(this.objs);
      this.objects = this.objs;
      if (selected) {
        selected.forEach(s => {
          this.selectObject(s.id, this.objects);
        });
        createObjectExpandedTreeByKey(this.objects, this.selected, false);
      }
      this.isShowSpinner = false;
    });
  }

  hasObjects(node) {
    if (Array.isArray(node)) {
      const n = [];
      node.forEach(_node => {
        if (this.hasObjects(_node)) {
          n.push(_node);
        }
      });
      node = n;
      return n.length > 0;
    }
    if (node.children) {
      return this.hasObjects(node.children);
    }
    return node.isObject;
  }

  selectBy(event) {
    this.searchByObjects = !this.searchByObjects;
    if (this.objfilter && this.objfilter.length >= 3) {
      this.objects = this.searchByObjects ? searchItemExpanded(_.cloneDeep(this.objs), this.objfilter, false) : searchItem(_.cloneDeep(this.objs), this.objfilter, false);
    }
  }

  onChange(filter, event, list, filtered) {
    this[filter] = event.target.value;
    if (this[filter].length >= 3) {
      this[filtered] = this.searchByObjects ? searchItemExpanded(_.cloneDeep(this[list]), this[filter], false) : searchItem(_.cloneDeep(this[list]), this[filter], false);
    } else {
      this[filtered] = this[list];
    }
  }

  nodeSelect(e) {
    this.selected.expanded = true;
    if (this.selected.expanded) {
      this.openNodes(this.selected);
    }
  }

  openNodes(node) {
    if (node.children && node.children.length === 1) {
      node.children[0].expanded = true;
      this.openNodes(node.children[0]);
    }
  }


  closeModal(val = null) {
    this.ref.close(val);
  }

  applySelection() {
    if (!this.selected) {
      this.messageService.message(gettext('Select object'));
      return;
    } else {
      this.closeModal({objects: this.selected, action: this.objaction});
    }

  }

  selectAllRecursive(tree: TreeNode[], type: string) {
    for (const node of tree) {
      this[type].push(node);
      if (node.children) {
        this.selectAllRecursive(node.children, type);
      }
    }
  }

  selectObject(id, tree) {
    tree.forEach(val => {

      if (val.id === id) {
        val.expanded = true;
        if (val.isObject) {
          this.selected.push(val);
        }
      }
      if (val.children) {
        this.selectObject(id, val.children);
      }
    });
  }

  private addNode(tree: any[], node: any) {
    const found = tree.filter(f => f.id === node.id);
    if (found.length === 0) {
      tree.push(node);
    }
  }

  public selectAll(type: 'selected', all: 'allObjects', filtered: 'objects', isAppend?: boolean) {
    const append = isAppend ? _.cloneDeep(this[type]) : [];
    this[type] = [];
    this[all] = !this[all];
    if (this[all]) {
      this.selectAllRecursive(this[filtered], type);
      if (isAppend) {
        if (this[type] && append.length > 0) {
          append.forEach(a => {
            this.addNode(this[type], a);
          });
        }
      }
    } else if (isAppend) {
      this.selectAllRecursive(this[filtered], type);
      if (this[type] && append.length > 0) {
        this[type].forEach(_f => {
          const index = append.findIndex(a => a.id === _f.id);
          if ( index  !== -1) {
            append.splice(index, 1);
          }
        });
      }
      this[type] = _.cloneDeep(append);
    }
  }

  private sortNodes(items: any) {
    if (items) {
      items.sort(this.compareNodes);
      for (let i = 0; i < items.length; i++) {
        if (items[i].children && items[i].children.length > 0) {
          this.sortNodes(items[i].children);
        }
      }
    }
  }

  private compareNodes(a: any, b: any): number {
    if (a.label > b.label) {
      return 1;
    } else {
      if (a.label < b.label) {
        return -1;
      } else {
        return 0;
      }
    }
  }

  highlight(value: string, text): string {
    const regex = new RegExp('(' + text + ')', 'gi');
    return value.replace(regex, '<span class="u-text-highlight">$1</span>');
  }
}
